import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import {
  EMPTY_PACKAGE_SEARCH_FILTERS,
  paramsFromPackageSearchFilters,
} from '../types/marketplaceSearch';

interface DestinationProps {
  name: string;
  image: string;
  price: number;
  primaryColor: string;
  /** Texte pour le filtre destination sur la liste des séjours (`/offres`, param `d=`) ; défaut : le nom affiché */
  filterDestination?: string;
}

export default function DestinationCard({
  name,
  image,
  price,
  primaryColor,
  filterDestination,
}: DestinationProps) {
  const dest = (filterDestination ?? name).trim();
  const offresQuery = paramsFromPackageSearchFilters({
    ...EMPTY_PACKAGE_SEARCH_FILTERS,
    destination: dest,
  }).toString();
  const offresTo = offresQuery ? `/offres?${offresQuery}` : '/offres';

  return (
    <div className="group relative w-full overflow-hidden rounded-xl">
      {/* Format portrait vertical : ratio 2/3 (plus haut que large) */}
      <div className="relative aspect-[2/3] w-full">
        <div className="absolute inset-0 z-10 bg-black/20 transition-colors duration-300 group-hover:bg-black/30" />
        <img
          src={image}
          alt={name}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 z-20 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 z-30 p-4 md:p-5">
          <div className="mb-3 flex items-center gap-2">
            <MapPin className="h-5 w-5 shrink-0 text-white" />
            <span className="text-base font-semibold text-white md:text-lg">{name}</span>
          </div>
          <div className="flex w-full items-end justify-between gap-3">
            <div className="min-w-0 text-white">
              <p className="text-sm text-gray-300">À partir de</p>
              <p className="text-xl font-bold tabular-nums leading-tight md:text-2xl">
                {price.toLocaleString('fr-DZ')} DA
              </p>
            </div>
            <div className="shrink-0">
              <Link
                to={offresTo}
                className="relative z-30 inline-block rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:opacity-90"
                style={{ backgroundColor: primaryColor }}
              >
                Réserver
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}